<div class="ttmodal__header" style="margin-bottom:15px">
    <span class="ttmodal__title" style="font-size:20px">
        Set Component Column Order
    </span>

    <i class="material-icons ttmodal__close-button"
       style="cursor:pointer;float:right"
       (click)="onCloseClick()">
        close
    </i>
</div>

<div class="dialog">

    <mat-list class="header-form-full-width">

        <mat-list-item *ngFor="let column of sortedComponentColumns; let i = index">

            <div class="column-item">

                <!-- Checkbox -->
                <mat-checkbox
                    [(ngModel)]="column.visible" (change)="toggleColumn(column)"> 
                </mat-checkbox>

                <!-- Column Name -->
                <span class="column-title">
                    {{ column.title }}
                </span>

                <!-- Move Buttons -->
                <div class="column-actions">

                    <mat-icon
                        (click)="moveDown(column)"
                        [class.button-hide]="i === sortedComponentColumns.length - 1">
                        arrow_downward
                    </mat-icon>

                    <mat-icon
                        (click)="moveUp(column)"
                        [class.button-hide]="i === 0">
                        arrow_upward
                    </mat-icon>

                </div>

            </div>

        </mat-list-item>

    </mat-list>

</div>